import axiosBaseURL from "../../../httpCommon";
import React, { useEffect, useState, useContext, useRef } from "react";
import Slider from "react-slick";
import { DrtContext } from "../../../context/DrtContext";
import { imageURL } from "../../../constants";
import Loader from "../../Loader";

const LatestNews = () => {
  const slider = useRef();
  const { lang, EncryptDecrypt } = useContext(DrtContext);
  const [update, setUpdate] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [playPause, setPlayPause] = useState(false);

  const getLatestUpdate = async () => {
    setIsLoading(true);
    try {
      const result = await axiosBaseURL.get("/get-latestupdate");

      const temp = EncryptDecrypt(result.data);

      setUpdate(temp.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while fetching the data.");
    }
    setIsLoading(false);
  };
useEffect(() => {
  getLatestUpdate();
}, []);

 
  const settings = {
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 500,          
  autoplaySpeed: 2000, 
  cssEase: "ease",
};


  if (error) {
    return <div>Error: {error}</div>;
  }

  if (isLoading) {
    return <Loader />;
  }

  const handlePlayPause = () => {
    setPlayPause(!playPause);
    if (playPause) {
      slider.current.slickPlay();
    } else {
      slider.current.slickPause();
    }
  };

  return (
    <>
      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
        <div className="news-slider">
          <div className="heading">
            <h3>{lang === "en" ? "Latest Update" : "ताजा अपडेट"}</h3>
          </div>
          <Slider {...settings} ref={slider}>
            {update.length > 0 ? (
              update.map((item, index) => (
                <div
                  key={item.id}
                  className={
                    index === 0 ? "carousel-item active" : "carousel-item"
                  }
                >
                  <a
                    type="button"
                    // href="https://drt.etribunals.gov.in/front/efiling_notice.pdf"
                    href={`${imageURL}/efiling_notice.pdf`}
                    target="_blank"
                  
                    rel="noopener noreferrer"
                  >
                    {item.summery}
                  </a>
                </div>
              ))
            ) : (
              <>No Data Found</>
            )}
          </Slider>
          <a onClick={handlePlayPause} className="btn pause">
            {!playPause ? (
              <span>
                <i className="fas fa-pause-circle"></i>
                Pause
              </span>
            ) : (
              <span>
                <i className="fas fa-play"></i>
                Play
              </span>
            )}
          </a>
        </div>
        
      </div>
    </>
  );
};

export default LatestNews;
